import React, { useMemo } from "react";
import { Package } from "lucide-react";

import { DashboardCard } from "../DashboardCard";
import { CardHeader } from "../CardHeader";
import { DashboardDropdown } from "../DashboardDropdown";
import {
  DonutChart,
  DonutLegend,
  categoryColorMap,
} from "../charts/DonutChart";

import {
  getAssetStatusData,
  getAssetCategoryData,
} from "../../services/dashboardAnalytics";

import { ASSET_STATUS_COLORS } from "../../constants/constants";

const ASSET_VIEW_OPTIONS = [
  { value: "STATUS", label: "By Status" },
  { value: "TYPE", label: "By Type" },
];

export const AssetsOverviewCard = React.memo(function AssetsOverviewCard({
  assets,
  assetView,
  onAssetViewChange,
}) {
  const statusData = useMemo(
    () => getAssetStatusData(assets),
    [assets]
  );

  const categoryData = useMemo(
    () => getAssetCategoryData(assets),
    [assets]
  );

  const isStatus = assetView === "STATUS";

  const activeData = isStatus ? statusData : categoryData;

  const categoryColors = useMemo(
    () => categoryColorMap(categoryData),
    [categoryData]
  );

  const colors = isStatus ? ASSET_STATUS_COLORS : categoryColors;

  return (
    <DashboardCard>
      <CardHeader
        icon={Package}
        iconBg="#EFF6FF"
        iconColor="#2563EB"
        title="Assets Overview"
        action={
          <DashboardDropdown
            value={assetView}
            options={ASSET_VIEW_OPTIONS}
            onChange={onAssetViewChange}
          />
        }
      />

      <div className="text-xs text-slate-400 font-medium mb-1">
        Assets by {isStatus ? "Status" : "Type"}
      </div>

      <div className="grid grid-cols-2 gap-2 items-center flex-1">
        <DonutChart
          data={activeData}
          colors={colors}
          total={assets.length}
          centerLabel="Total"
        />

        <div className="max-h-[220px] overflow-y-auto pr-1">
          <DonutLegend
            data={activeData}
            colors={colors}
          />
        </div>
      </div>
    </DashboardCard>
  );
});